<template>
    <div id="PopupDelay" class="loading-wrapper" v-if="isActive">
        <Loader id="page-loader" v-if="loading"></Loader>
        <div :class="'loading-popup popup-' + type">
            <div class="h-100 m-5 align-items-center text-center m-0">
                <div class="row">
                    <div class="col align-items-center">
                        <!-- <div class="float-left">
                            <img v-if="type == 'success'" class="icon" :src="require('@/assets/images/check-circle.png')" />
                            <img v-if="type == 'danger'" class="icon" :src="require('@/assets/images/danger.png')" />
                        </div> -->
                        <div class="closeDelay" @click="closeDelayPopup">
                            <font-awesome-icon class="times" :icon="['fas', 'times']" />
                        </div>
                        
                        <div class="text-left d-inline-block">
                            <h2 class="popup-title" style="margin: 0 20px;">{{title}}</h2>
                            <span class="message">{{message}}</span>
                            <hr>
                            <div class="delay">
                                <span>{{$t('Teller.ComeBackAfter')}}</span>
                                <input type="time" class="time" v-model="delay.delay">
                                <span v-if="$i18n.locale == 'ar'" style="margin: 0 20px;">{{$t('Teller.NotifyClient')}}</span><input type="checkbox" v-model="delay.notify" class="checkbox"><span v-if="$i18n.locale != 'ar'" style="margin: 0 20px;">{{$t('Teller.NotifyClient')}}</span>
                                <textarea class="" v-model="delay.message" v-if="delay.notify" :placeholder="$t('Teller.WriteNotif')"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4" v-if="hint">
                    <span class="hint">{{hint}}</span>
                </div>

                <button class="btn-confirm" @click="clicked()">{{confirmationButton}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { queueService } from '../../_services'
    import Loader from '../loader/Loader.vue'

    export default {
        name: 'LoadingPopup',
        data:()=>({
            delay: {
                delay: "00:00",
                message: "",
                notify: true
            },
            loading: false
        }),
        props: {
            active: Boolean,
            title: String,
            message: String,
            hint: String,
            type: String,
            confirmationButton: String
        },
        methods: {
            clicked(){
                const self= this
                this.loading= true
                console.log(this.delay)
                queueService.addDelay(this.$route.params.id, this.delay).then(function(data){
                    console.log(data)
                }).finally(function(){
                    self.$router.go();
                })
            },
            closeDelayPopup(){
                this.$emit('close')
            }
        },
        computed: {
            isActive(){
                return this.active;
            }
        },
        components: {
            Loader
        }
    }
</script>

<style>
    .loading-wrapper{
        background: rgba(0, 0, 0, 0.70);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }

    .loading-popup{
        width: 60%;
        max-width: 500px;
        min-width: 300px;
        background: #ffffff;
        border-radius: 20px;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        color: #264076;
    }

    .loader{
        width: 50px;
        height: 50px;
    }

    .popup-success .popup-title {
        color: #bed24c !important;
        margin-bottom: 0px;
        font-size: 20px !important;
        display: flex;
    }

    .popup-success  .icon {
        width: 70px;
        margin: 10px 10px;
    }

    .popup-success  .message {
        color: #444;
        font-weight: lighter;
        font-size: 18px;
    }

    .popup-success  .hint {
        color: #333;
        font-weight: bold;
        font-size: 16px;
    }

    .popup-success .btn-confirm {
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 0px 0px 20px 20px;
        padding: 15px;
        width: 100%;
        border: none;
        background: #bed24c;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
    }

    .popup-success .btn-confirm:not(:disabled):not(.disabled):active, .btn-confirm:not(:disabled):not(.disabled).active, .show > .btn-confirm.dropdown-toggle {
        color: #fff;
        background-color: #bed24c;
        border-color: #bed24c;
    }

    .popup-success .btn-confirm:focus, .btn-confirm.focus {
        box-shadow: none;
    }

    .popup-danger .popup-title {
        color: #DC3545 !important;
        margin-bottom: 0px;
        font-size: 42px !important;
        display: flex;
    }

    .popup-danger  .icon {
        width: 70px;
        margin: 10px 10px;
    }

    .popup-danger  .message {
        color: #444;
        font-weight: lighter;
        font-size: 18px;
    }

    .popup-danger  .hint {
        color: #333;
        font-weight: bold;
        font-size: 16px;
    }

    .popup-danger .btn-confirm {
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 0px 0px 20px 20px;
        padding: 15px;
        width: 100%;
        border: none;
        background: #DC3545;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
    }

    .popup-danger .btn-confirm:not(:disabled):not(.disabled):active, .btn-confirm:not(:disabled):not(.disabled).active, .show > .btn-confirm.dropdown-toggle {
        color: #fff;
        background-color: #DC3545;
        border-color: #DC3545;
    }

    .popup-danger .btn-confirm:focus, .btn-confirm.focus {
        box-shadow: none;
    }
    .delay{
        padding: 30px 0;
        margin-top: -20px;
    }
    .delay .time{
        width: 100%;
        height: 50px;
        border: 1px solid #264076;
        padding: 0 10px;
        border-radius: 10px;
    }
    .delay .checkbox{
        display: inline-block;
        margin: 20px 0;
    }
    .delay textarea{
        display: block;
        height: 70px;
        width: 100%;
        border: 1px solid #264076;
        padding: 0 10px;
        border-radius: 10px;
    }
    .closeDelay{
        float: right;
        font-size: 17px;
        color: #bed24c;
        padding: 5px 10px;
        border: 1px solid #bed24c;
        border-radius: 50px;
        transition: .3s;
        position: absolute;
        right: 0;
    }
    .closeDelay:hover{
        color: #fff;
        background-color: #bed24c;
    }
</style>